var scope_0 = require('C:/Jenkins/workspace/ELAPSEIT-PRODUCTION-WEBSITE-WW1-FR/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/33837dbd40001c0f3710e350e94fc188.js').default;
var scope_1 = require('C:/Jenkins/workspace/ELAPSEIT-PRODUCTION-WEBSITE-WW1-FR/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/54c81d5b8dcf4a8bdffea976ea81cc08.js').default;
var scope_2 = require('C:/Jenkins/workspace/ELAPSEIT-PRODUCTION-WEBSITE-WW1-FR/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/df4185f0bca8ac60c02007b012e35dc6.js').default;
var scope_3 = require('C:/Jenkins/workspace/ELAPSEIT-PRODUCTION-WEBSITE-WW1-FR/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    